import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useState, useEffect } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { format, startOfDay, endOfDay } from 'date-fns'
import { useQueryState, parseAsString } from 'nuqs'
import useQueryGetPlayerWithDepositsWithoutPromotion from '@/modules/manage-player/api/hooks/useQueryGetPlayerWithDepositsWithoutPromotion'
import PlayerWithDepositsWithoutPromotionListing from '@/modules/manage-player/components/PlayerWithDepositsWithoutPromotion/components/PlayerWithDepositsWithoutPromotionListing'

type SortOrder = 'asc' | 'desc' | undefined

function PlayerWithDepositsWithoutPromotionPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const [depositAmountSort, setDepositAmountSort] = useState<SortOrder>('desc')
	const [depositTimeSort, setDepositTimeSort] = useState<SortOrder>()

	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'totalDepositAmountWithoutPromotion') {
			setDepositAmountSort(order)
			setDepositTimeSort(undefined)
		} else if (columnId === 'totalDepositTimeWithoutPromotion') {
			setDepositTimeSort(order)
			setDepositAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		depositAmountSort,
		depositTimeSort,
	}

	const { data, isLoading } =
		useQueryGetPlayerWithDepositsWithoutPromotion(payload)

	return (
		<PageContainer>
			<PlayerWithDepositsWithoutPromotionListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				onSort={handleSort}
			/>
		</PageContainer>
	)
}

const GuardedPlayerWithDepositsWithoutPromotionPage = withUserPermission(
	PlayerWithDepositsWithoutPromotionPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_PLAYER],
	},
)

export default GuardedPlayerWithDepositsWithoutPromotionPage
